import { render } from "./OapToastNotification.vue?vue&type=template&id=79cd9d2f"
import script from "./OapToastNotification.vue?vue&type=script&lang=js"
export * from "./OapToastNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__